import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {poolVariant} from '@/common/types/commonTypes.ts'
import {loadAllData, loadData} from "@/redux/poolThunks.ts";
import BN from "bn.js";

// const initialState = {
//   guaranteedPoolAmount: '',
//   growPoolAmount: '',
//   guaranteedNRGpercent: '',
//   growNRGpercent: '',
//   isEnterToPoolDialogOpened: false,
//   buttonClicked: 'safe',
//   poolZNXLimit: '0',
//   statGrowthTotalZnx: '0',
//   statGuaranteedTotalZnx: '0'
// }
//


export type UserOnPool = {
  safeAmount: BN
  growthAmount: BN
  safePercentBps: number
  growthPercentBps: number,
  poolId: PoolId,

  safePayoutState: boolean[],
  growthPayoutState: boolean[],

  safeMonthlyUsdcPayout: BN[],
  growthMonthlyUsdcPayout: BN[],

  safeMonth12ZnxPayout: BN,
  growthMonth12ZnxPayout: BN
}

export type PoolState = {
  poolZnxLimit: BN
  statGrowthTotalZnx: BN
  statSafeTotalZnx: BN
  monthlyNgrs: BN[]
  monthlyPaymentOpen: boolean[]
  monthHasNgrs: boolean[]
  currentMonth: number
}

export type PoolIdKey = string // например: '2025-07'

export type PoolSliceState = {
  userData: Record<PoolIdKey, UserOnPool>
  poolData: Record<PoolIdKey, PoolState>
  isEnterToPoolDialogOpened: boolean
  buttonClicked: poolVariant
}

export type PoolId = {
  code: string
  year: number
  month: number
}

const initialState = {
  userData: {} as Record<PoolIdKey, UserOnPool>,
  poolData: {} as Record<PoolIdKey, PoolState>,
  sortedUserPoolIds: [] as PoolId[],
  sortedPoolIds: [] as PoolId[],
  curUserData: undefined as UserOnPool | undefined,
  curPoolData: {
    poolZnxLimit: new BN(0),
    statGrowthTotalZnx: new BN(0),
    statSafeTotalZnx: new BN(0),
  } as PoolState,

  isEnterToPoolDialogOpened: false,
  buttonClicked: 'safe'
}


const poolSlice = createSlice({
  name: 'pool',
  initialState,
  reducers: {


    // setGuaranteedAmount(state, action: PayloadAction<string>) {
    //   state.guaranteedPoolAmount = action.payload
    // },
    // setGrowAmount(state, action: PayloadAction<string>) {
    //   state.growPoolAmount = action.payload
    // },
    // setGuaranteedNRG(state, action: PayloadAction<string>) {
    //   state.guaranteedNRGpercent = action.payload
    // },
    // setGrowNRG(state, action: PayloadAction<string>) {
    //   state.growNRGpercent = action.payload
    // },
    setEnterDialogOpened(state, action: PayloadAction<boolean>) {
      state.isEnterToPoolDialogOpened = action.payload
    },
    setButtonClicked(state, action: PayloadAction<poolVariant>) {
      state.buttonClicked = action.payload
    },
    // setPoolZNXLimit(state, action: PayloadAction<string>) {
    //   state.poolZNXLimit = action.payload
    // },
    // setStatGrowthTotalZnx(state, action: PayloadAction<string>) {
    //   state.statGrowthTotalZnx = action.payload
    // },
    // setStatGuaranteedTotalZnx(state, action: PayloadAction<string>) {
    //   state.statGuaranteedTotalZnx = action.payload
    // }
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadData.pending, () => {
        console.info('loadData.pending')
      })
      .addCase(loadData.fulfilled, (state, action) => {
        let  curUserData = state.curUserData
        if (action.payload.userData) {
           curUserData = {

            growthAmount: action.payload.userData.growthAmount,
            growthPercentBps: action.payload.userData.growthPercentBps,
            safeAmount: action.payload.userData.guaranteedAmount,
            safePercentBps: action.payload.userData.guaranteedPercentBps,
            poolId: {
              month: action.payload.userData.month,
              year: action.payload.userData.year,
              code:'kz'
            },

            safePayoutState: action.payload.userData.guaranteedPayoutState,
            growthPayoutState: action.payload.userData.growthPayoutState,

            safeMonthlyUsdcPayout: action.payload.userData.guaranteedMonthlyUsdcPayout,
            growthMonthlyUsdcPayout: action.payload.userData.growthMonthlyUsdcPayout,

            safeMonth12ZnxPayout: action.payload.userData.guaranteedMonth12ZnxPayout,
            growthMonth12ZnxPayout: action.payload.userData.growthMonth12ZnxPayout,
          }
        }


        const curPool: PoolState = {
          poolZnxLimit: (action.payload.poolData.poolZnxLimit),
          statGrowthTotalZnx: (action.payload.poolData.statGrowthTotalZnx),
          statSafeTotalZnx: (action.payload.poolData.statGuaranteedTotalZnx),

          monthlyNgrs: (action.payload.poolData.monthlyNgrs),
          monthlyPaymentOpen: (action.payload.poolData.monthlyPaymentOpen),
          monthHasNgrs: (action.payload.poolData.monthHasNgrs),
          currentMonth:1, //todo
        }

        state.curPoolData = curPool
        state.curUserData = curUserData
      })
      .addCase(loadData.rejected, () => {
        console.warn('loadData.rejected')
      })
      .addCase(loadAllData.pending, () => {
        console.info('loadAllData.pending')
      })
      .addCase(loadAllData.fulfilled, (state, action) => {

        const userData = {} as Record<PoolIdKey, UserOnPool>;
        const poolData = {} as Record<PoolIdKey, PoolState>;
        const userPoolIds: PoolId[] = [];

        (action.payload.userData ?? []).forEach((el) => {
          const id = "" + el.account.year + "-" + el.account.month
          userPoolIds.push(
            {
              month: el.account.month,
              year: el.account.year,
              code:'kz'
            }
          )

          userData[id] = {
            growthAmount: el.account.growthAmount,
            growthPercentBps: el.account.growthPercentBps,
            safeAmount: el.account.guaranteedAmount,
            safePercentBps: el.account.guaranteedPercentBps,

            safePayoutState: el.account.guaranteedPayoutState,
            growthPayoutState: el.account.growthPayoutState,

            safeMonthlyUsdcPayout: el.account.guaranteedMonthlyUsdcPayout,
            growthMonthlyUsdcPayout: el.account.growthMonthlyUsdcPayout,

            safeMonth12ZnxPayout: el.account.guaranteedMonth12ZnxPayout,
            growthMonth12ZnxPayout: el.account.growthMonth12ZnxPayout,

            poolId: {
              month: el.account.month,
              year: el.account.year,
              code:'kz'
            },
          }
        })



        const poolIds: PoolId[] = []

        for (const a in action.payload.poolData) {
          const id = "" + action.payload.poolData[a].account.year + "-" + action.payload.poolData[a].account.month
          poolIds.push(
            {
              month: action.payload.poolData[a].account.month,
              year: action.payload.poolData[a].account.year,
              code:'kz'
            }
          )

          poolData[id] = {
            poolZnxLimit: action.payload.poolData[a].account.poolZnxLimit,
            statGrowthTotalZnx: action.payload.poolData[a].account.statGrowthTotalZnx,
            statSafeTotalZnx: action.payload.poolData[a].account.statGuaranteedTotalZnx,
            monthlyNgrs: (action.payload.poolData[a].account.monthlyNgrs),
            monthlyPaymentOpen: (action.payload.poolData[a].account.monthlyPaymentOpen),
            monthHasNgrs: (action.payload.poolData[a].account.monthHasNgrs),
            currentMonth: (action.payload.poolData[a].account.currentMonth),
          }
        }

        const sortedPoolIds = poolIds.sort((a, b) => {
          if (a.year !== b.year) {
            return b.year - a.year
          }
          return b.month - a.month
        })

        const sortedUserPoolIds = userPoolIds.sort((a, b) => {
          if (a.year !== b.year) {
            return b.year - a.year
          }
          return b.month - a.month
        })

        state.userData = userData
        state.poolData = poolData
        state.sortedUserPoolIds = sortedUserPoolIds
        state.sortedPoolIds = sortedPoolIds

        // console.log('pool and user data',state.poolData, state.userData,action.payload.userData, state.sortedUserPoolIds, state.sortedPoolIds)
      }).addCase(loadAllData.rejected, () => {
      console.warn('loadAllData.pending')
    })
  }
})

export const {
  setEnterDialogOpened,
  setButtonClicked,
} = poolSlice.actions


export const poolReducer = poolSlice.reducer